export default __webpack_public_path__ + "static/originalGradient-88849ca935d1aa70733d7dfe8f9dbd02.webp";